<template>
    <c-modal @close="close" :title="uitklaren ? 'Artikelen uitklaren' : 'Artikelen inklaren'">

        <c-form ref="form" class="margin-t-32">

            <div v-for="product, index in products" :key="product.id" class="margin-b-32">

                <h6 class="margin-b-16">{{ product.product ? product.product.name : product.name }}</h6>

                <div class="font-heading margin-b-16" v-if="product.items || product.items > 0 || product.arrived > 0">
                    <span class="fw-bold color-gray-600 margin-r-32">Totaal ingeklaard</span>
                    <span class="fw-bold" v-if="product.items && !product.arrived">{{ product.items.length }}</span>
                    <span class="fw-bold" v-else-if="product.total">{{ product.total }}</span>
                    <span class="fw-bold" v-else-if="product.arrived && product.items">{{ product.arrived + product.items.length }}</span>
                    <span class="fw-bold" v-else-if="product.arrived && !product.items">{{ product.arrived }}</span>
                    <span class="color-gray-600"> / {{ product.expected ? product.expected : "1" }}</span>
                </div>

                <div class="font-heading margin-b-16" v-if="!uitklaren">
                    <span class="fw-bold color-gray-600 margin-r-32">Controle</span>
                    <c-input
                        :label="'Controlegetal'"
                        :horizontal="true"
                        :row="true"
                        :after="product.expected ? product.expected - product.arrived : '0'"
                        type="number"
                        class="c-form-element--medium"
                        :name="'control_number-' + index"/>
                </div>

                <h6 class="margin-t-32 margin-b-16">Kies een verwerkingswijze</h6>

                <div v-if="(product.expected !== product.arrived && !product.quantityActive) || (product.pickup && !product.quantityActive)" class="c-btn-group">
                    <button @click="openModalScanPrenotification(product)" class="c-btn c-btn--hollow c-btn--gray-600">Serienummers scannen</button> 
                    <div class="margin-t-12">of</div>
                    <button @click="showQuantity(product)" class="c-btn c-btn--hollow c-btn--gray-600">Aantal toevoegen</button>
                </div>  
                <div v-else>
                    <c-input
                        :label="'Aantal'"
                        :horizontal="true"
                        :row="true"
                        :after="product.expected"
                        type="number"
                        class="c-form-element--medium"
                        name="item-quantity"
                        v-model="product.quantity"/>
                </div>
                <hr/>
            </div>

            <div class="row collapse align-right">
                <div class="columns shrink c-btn-group">
                    <c-button class="margin-t-32 margin-b-16 no-margin-b" :disabled="submitting || totalQuantity" type="submit" @click="saveAndCompleteMethod()">Opslaan
                    </c-button>
                    <c-button class="margin-t-32 margin-b-16 no-margin-b c-btn"
                              v-if="this.$route.name !== 'preNotificationDetail'" :disabled="submitting || totalQuantity"
                              @click="saveAndCompleteDeliveryMethod()">Opslaan & Afronden
                    </c-button>
                </div>
            </div>
        </c-form>
    </c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CScanPrenotification from '@app/modals/ScanPrenotification';
import {ValidationError} from '@app/errors';

export default {
    mixins: [Form],
    components: {
        CModal, CScanPrenotification
    },
    props: {
        products: {
            type: Array
        },
        uitklaren: {
            type: Boolean
        },
        bulk: {
            type: Boolean,
            default: false
        },
        delivery_id: {
            type: Number
        },
        orderNumber: {
            type: String
        }
    },
    data() {
        return {
            quantityActive: '',
            quantity: '',
            items: [],
            products_without_serial: '',
            submitting: false,
            saveAndCompleteDelivery: false,
            saveAndComplete: false,
            control_number: ''
        };
    },
    computed: {
        totalQuantity() {
            if(this.products.reduce((total, product) => total + (product.quantity || 0), 0) !== 0 ){
                return false
            }
            if(this.products.filter((product) => product.items && product.items.length !== 0).length !== 0){
                return false
            }

            return true
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        showQuantity(product) {
            product.quantityActive = 1;
        },
        openModalScanPrenotification(product) {
            product.quantityActive = 0;
            event.preventDefault();
            this.close();
            this.$emit('open-modal-scan-prenotification');
            this.$emit('get-data', product);
        },
        saveAndCompleteMethod() {
            this.saveAndComplete = true;
            this.submit();
        },
        saveAndCompleteDeliveryMethod() {
            this.saveAndCompleteDelivery = true;
            this.submit();
        },
        submit() {
            this.submitting = true;

            let submitData = {
                items: []
            };

            let productData = {
                products: []
            };

            for (const product of this.products) {

                let itemsData = {
                    items: []
                }

                if (product.quantity) {
                    if (product.arrived) {
                        product.arrived = product.arrived + product.quantity;
                    } else {
                        product.arrived = product.quantity;
                    }

                    for (let j = 0; j < product.quantity; j++) {
                        if (this.uitklaren) {
                            itemsData = {
                                product_id: product.id,
                                order_number: this.orderNumber,
                            }
                            submitData['items'].push(itemsData);
                        } else {
                            itemsData = {
                                product_id:product.product.id,
                                order_number: this.orderNumber,
                                daas: product.daas,
                                stock_owner: product.stock_owner,
                            }
                            submitData['items'].push(itemsData);
                        }
                    }
                }
                else if (product.items) {
                    if (product.arrived) {
                        product.arrived = product.items.length + product.arrived;
                        product.total = product.items.length + product.arrived;
                    } else {
                        product.arrived = product.items.length;
                        product.total = product.items.length;
                    }

                    for (const item of product.items) {
                        if (product.product) {
                            itemsData = {
                                product_id: product.product.id,
                                serial: item.serialNumber,
                                order_number: this.orderNumber,
                                daas: product.daas,
                                stock_owner: product.stock_owner,
                            }
                        } else if (this.bulk) {
                            itemsData = {
                                product_id: product.id,
                                serial: item.serialNumber,
                                order_number: this.orderNumber,
                            }
                        } 
                        else {
                            product.serial = item.serialNumber;
                            product.status = "uitgeklaard";
                        }

                        submitData['items'].push(itemsData);
                    }
                }

                productData['products'].push(product);
            }

            let data = Object.assign(submitData, productData);

            if (this.uitklaren) {

                if (this.bulk) {
                    let delivery_id = {delivery_id: this.delivery_id};
                    data = Object.assign(submitData, delivery_id);

                    this.$xhr.post('/api/items/scanbulkitems', data).then(({result}) => {

                        this.$emit('added');
                        this.$store.dispatch('toast/success', { title: 'Items uitklaren', text: 'De items zijn uitgeklaard' });
                        this.submitting = false;

                        if (this.saveAndCompleteDelivery) {
                            this.$xhr.post('/api/delivery/save-and-finish', {id: this.delivery_id});
                        } else {
                            this.$xhr.post('/api/delivery/save', {id: this.delivery_id});
                        }

                    }).catch((e) => {
                        if (e instanceof ValidationError) {
                            this.$refs.form.setErrors(e.errors);
                        }
                        this.submitting = false;
                        this.$emit('added');
                        this.$store.dispatch('toast/alert', {title: 'Items uitklaren mislukt', text: e.result});
                    });

                    this.close();
                } 
                else {

                    this.$xhr.post('/api/items/scanitems', productData).then(({result}) => {

                        if (this.saveAndCompleteDelivery) {
                            this.$xhr.post('/api/delivery/save-and-finish', {id: this.delivery_id}).then(({result2}) => {
                                this.$store.dispatch('toast/success', { title: 'Items uitklaren', text: 'De items zijn uitgeklaard'});
                            });
                        }
                        else {
                            this.$xhr.post('/api/delivery/save', {id: this.delivery_id});
                        }

                        this.submitting = false;
                        this.close();
                        this.$emit('added');

                    }).catch((e) => {
                        if (e instanceof ValidationError) {
                            this.$refs.form.setErrors(e.errors);
                        }
                        this.close();
                        this.submitting = false;
                        this.$emit('added');
                        this.$store.dispatch('toast/alert', {title: 'Items uitklaren mislukt', text: e.result});
                    });
                }
            }
            else {
                this.$xhr.post('/api/items', data).then(({result}) => {
                    this.close();
                    this.$emit('added');
                    this.$store.dispatch('toast/success', { title: 'Voormelding ingeklaard', text: 'De voormelding is ingeklaard' });
                }).catch((e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.$store.dispatch('toast/alert', { title: 'Voormelding inklaren mislukt', text: 'Er is helaas iets fout gegaan bij het inklaren van de voormelding' });
                });
            }
            this.submitting = false;
        }
    }
}
</script>
